var _defs, _g, _g2, _g3, _path, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #2f69ea;\n      }\n\n      .st1 {\n        fill: #f6f6f6;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: none;\n      }\n\n      .st4 {\n        fill: #e0e0e0;\n      }\n\n      .st5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st6 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st7 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st8 {\n        fill: #73a6ff;\n      }\n\n      .st9 {\n        fill: #265ab5;\n      }\n\n      .st10 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 5.33,
    y: 24,
    width: 53.33,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 5.33,
    y: 0,
    width: 53.33,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 5.33,
    y: 0,
    width: 53.33,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.67,57.33c0,3.68-2.98,6.67-6.67,6.67H12c-3.68,0-6.67-2.98-6.67-6.67V6.67C5.33,2.98,8.32,0,12,0h32l14.67,14.67v42.67Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,63.33c-3.31,0-6-2.69-6-6V6.67c0-3.31,2.69-6,6-6h31.72l14.28,14.28v42.39c0,3.31-2.69,6-6,6H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44,0H12C8.32,0,5.33,2.98,5.33,6.67v50.67c0,3.68,2.98,6.67,6.67,6.67h40c3.68,0,6.67-2.98,6.67-6.67V14.67L44,0ZM43.45,1.33l13.89,13.89v42.11c0,2.94-2.39,5.33-5.33,5.33H12c-2.94,0-5.33-2.39-5.33-5.33V6.67c0-2.94,2.39-5.33,5.33-5.33h31.45Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,63.33c-3.31,0-6-2.69-6-6V6.67c0-3.31,2.69-6,6-6h31.72l14.28,14.28v42.39c0,3.31-2.69,6-6,6H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M44,0H12C8.32,0,5.33,2.98,5.33,6.67v50.67c0,3.68,2.98,6.67,6.67,6.67h40c3.68,0,6.67-2.98,6.67-6.67V14.67L44,0ZM43.45,1.33l13.89,13.89v42.11c0,2.94-2.39,5.33-5.33,5.33H12c-2.94,0-5.33-2.39-5.33-5.33V6.67c0-2.94,2.39-5.33,5.33-5.33h31.45Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M45.91,12.67l12.91,12.91v-12.91h-12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M58.67,14.67h-8c-3.68,0-6.67-2.98-6.67-6.67V0h14.67v14.67Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20,48l6.67-2.96v2.96c0,1.47,1.19,2.67,2.67,2.67h14.67c1.47,0,2.67-1.19,2.67-2.67v-12c0-1.47-1.19-2.67-2.67-2.67h-14.67c-1.47,0-2.67,1.19-2.67,2.67v2.96l-6.67-2.96v12Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.11,13.09c-.04-.94-.07-2.08-.07-3.22h-.04c-.24,1-.57,2.12-.87,3.03l-.95,3.06h-1.38l-.84-3.03c-.26-.92-.52-2.03-.71-3.06h-.02c-.05,1.06-.08,2.27-.14,3.24l-.14,2.98h-1.64l.5-7.84h2.36l.77,2.62c.24.91.49,1.88.66,2.8h.04c.22-.91.49-1.94.74-2.81l.84-2.6h2.31l.43,7.84h-1.73l-.12-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.32,8.36c.55-.09,1.31-.16,2.4-.16s1.87.21,2.4.63c.5.4.84,1.05.84,1.81s-.26,1.42-.72,1.86c-.6.57-1.5.83-2.55.83-.23,0-.44-.01-.6-.04v2.8h-1.76v-7.73ZM24.08,11.92c.15.04.34.05.59.05.94,0,1.52-.48,1.52-1.28,0-.72-.5-1.15-1.38-1.15-.36,0-.6.03-.73.07v2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.93,16.09v-1.8h-3.35v-1.15l2.86-4.6h2.16v4.43h.91v1.33h-.91v1.8h-1.67ZM31.93,12.96v-1.67c0-.45.02-.92.06-1.41h-.05c-.24.49-.44.93-.7,1.41l-1.01,1.65v.02h1.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.47ab90d003db27b8db391f93664fbbdf.svg";
export { ForwardRef as ReactComponent };